import { BaseNavigatorCommand } from "./BaseNavigatorCommand";
import { HelpCommand } from "./HelpCommand";
import { VersionCommand } from "./VersionCommand";

export class MainCommand extends BaseNavigatorCommand
{
    constructor(argv: string[], commands: { [name: string]: any })
    {
        super(argv, {
            "version": VersionCommand,
            "help": HelpCommand,
            ...commands
        });
    }
}